module.exports = __webpack_public_path__ + "img/map1.b6533399.jpg";